import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconH1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"h1, heading, headline"} maskId="square-filled-radius-0-stroke-1-IconH1"><path fillRule="evenodd" clipRule="evenodd" d="M3 4V11.5H13V4H14V20H13V12.5H3V20H2V4H3Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M21.0334 10H22.0033V20H21.0033V11.5127L18.534 14.2064L17.7969 13.5307L21.0334 10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconH1;
